import { Link } from "react-router-dom";
import logo from "../assets/investifylogo.png";

function Footer() {
  return (
    <footer className="pt-5 bg-light mt-5 border-top">
      <div className="container">
        <div className="row">
          {/* Logo + About */}
          <div className="col-md-4 col-sm-12 mb-4">
            <Link to="/" className="d-flex align-items-center mb-3">
              <img src={logo} alt="Investify Africa" style={{ width: 200 }} />
            </Link>
            <p className="text-muted small">
              Investify Africa helps you build wealth by investing in real
              estate projects — from land to apartments — in shares. Earn income
              without owning an entire property.
            </p>
          </div>

          {/* Navigation - About */}
          <div className="col-md-2 col-sm-6 mb-4">
            <h6 className="text-dark fw-bold">About</h6>
            <ul className="list-unstyled small">
              <li>
                <Link to="/how-it-works" className="text-muted">
                  How it works
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-muted">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigation - Business */}
          <div className="col-md-2 col-sm-6 mb-4">
            <h6 className="text-dark fw-bold">Business</h6>
            <ul className="list-unstyled small">
              <li>
                <Link to="/" className="text-muted">
                  Refer & Earn
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted">
                  Sell Property
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted">
                  Partnerships
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigation - Legal */}
          <div className="col-md-2 col-sm-6 mb-4">
            <h6 className="text-dark fw-bold">Legal</h6>
            <ul className="list-unstyled small">
              <li>
                <Link to="/" className="text-muted">
                  Security
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-2 col-sm-6 mb-4">
            <h6 className="text-dark fw-bold">Follow Us</h6>
            <ul className="list-unstyled small">
              <li>
                <a
                  href="https://www.facebook.com/investifyafrica"
                  target="_blank"
                  rel="noreferrer"
                  className="text-muted"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/investifyafrica/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-muted"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/investifyafrica"
                  target="_blank"
                  rel="noreferrer"
                  className="text-muted"
                >
                  Twitter
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/message/UPUPPRSASM7UL1"
                  target="_blank"
                  rel="noreferrer"
                  className="text-muted"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom line */}
        <div className="text-center pt-4 border-top">
          <p className="text-muted small mb-0">
            &copy; {new Date().getFullYear()} CodeCamp Technologies Ltd. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
